const defaultDescription = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Donec ullamcorper nulla non metus auctor fringilla.";
const defaultObjectives = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.\nMaecenas sed diam eget risus varius blandit sit amet non magna.";

const createProgramTemplate = (prefix) => ([
  {
    id: `${prefix}-program-1`,
    title: "Module 1 — Fondamentaux",
    items: [
      "Introduction à l’environnement de travail",
      "Organisation des vues, gabarits et méthodes de production",
    ],
  },
  {
    id: `${prefix}-program-2`,
    title: "Module 2 — Mise en pratique",
    items: [
      "Structuration d’un cas d’usage métier",
      "Bonnes pratiques de modélisation, vérification et restitution",
    ],
  },
  {
    id: `${prefix}-program-3`,
    title: "Module 3 — Production",
    items: [
      "Atelier guidé et méthodologie de travail",
      "Synthèse des acquis et préparation des usages en contexte projet",
    ],
  },
]);

const createQuestion = (id, questionText, answers, correctAnswerId, imageUrl = "") => ({
  id,
  questionText,
  imageUrl,
  answers,
  correctAnswerId,
});

export const defaultFormationsPageData = {
  id: "default-formations-page",
  createdAt: "2026-05-14T00:00:00.000Z",
  updatedAt: "2026-05-14T00:00:00.000Z",
  formations: [
    {
      id: "revit-toutes-les-bases",
      imageUrl: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3Nzg3NzAxMjN8MA&ixlib=rb-4.1.0&q=85",
      title: "Revit Toutes les Bases",
      description: defaultDescription,
      objectives: defaultObjectives,
      durationDays: 5,
      durationHours: 35,
      order: 1,
      isActive: true,
      prices: [
        { id: "revit-base-price-1", label: "Présentiel — CPF / financement", amount: 1200 },
        { id: "revit-base-price-2", label: "Distanciel — CPF / financement", amount: 1000 },
        { id: "revit-base-price-3", label: "Présentiel — financement personnel", amount: 700 },
        { id: "revit-base-price-4", label: "Distanciel — financement personnel", amount: 500 },
      ],
      programSections: createProgramTemplate("revit-bases"),
    },
    {
      id: "revit-specialisation-architecture",
      imageUrl: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3Nzg3NzAxMjN8MA&ixlib=rb-4.1.0&q=85",
      title: "Revit Spécialisation Architecture",
      description: defaultDescription,
      objectives: defaultObjectives,
      durationDays: 5,
      durationHours: 35,
      order: 2,
      isActive: true,
      prices: [
        { id: "revit-archi-price-1", label: "Présentiel — CPF / financement", amount: 1200 },
        { id: "revit-archi-price-2", label: "Distanciel — CPF / financement", amount: 1000 },
        { id: "revit-archi-price-3", label: "Présentiel — financement personnel", amount: 700 },
        { id: "revit-archi-price-4", label: "Distanciel — financement personnel", amount: 500 },
      ],
      programSections: createProgramTemplate("revit-archi"),
    },
    {
      id: "revit-specialisation-structure",
      imageUrl: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxidWlsZGluZyUyMHN0ZWVsJTIwc3RydWN0dXJlJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3ODc3MDEyM3ww&ixlib=rb-4.1.0&q=85",
      title: "Revit Spécialisation Structure",
      description: defaultDescription,
      objectives: defaultObjectives,
      durationDays: 5,
      durationHours: 35,
      order: 3,
      isActive: true,
      prices: [
        { id: "revit-structure-price-1", label: "Présentiel — CPF / financement", amount: 1200 },
        { id: "revit-structure-price-2", label: "Distanciel — CPF / financement", amount: 1000 },
        { id: "revit-structure-price-3", label: "Présentiel — financement personnel", amount: 700 },
        { id: "revit-structure-price-4", label: "Distanciel — financement personnel", amount: 500 },
      ],
      programSections: createProgramTemplate("revit-structure"),
    },
    {
      id: "revit-specialisation-cvc-plomberie-electricite",
      imageUrl: "https://images.unsplash.com/photo-1493476523860-a6de6ce1b0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxidWlsZGluZyUyMHN0ZWVsJTIwc3RydWN0dXJlJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3ODc3MDEyM3ww&ixlib=rb-4.1.0&q=85",
      title: "Revit Spécialisation CVC Plomberie Électricité",
      description: defaultDescription,
      objectives: defaultObjectives,
      durationDays: 5,
      durationHours: 35,
      order: 4,
      isActive: true,
      prices: [
        { id: "revit-cvc-price-1", label: "Présentiel — CPF / financement", amount: 1200 },
        { id: "revit-cvc-price-2", label: "Distanciel — CPF / financement", amount: 1000 },
        { id: "revit-cvc-price-3", label: "Présentiel — financement personnel", amount: 700 },
        { id: "revit-cvc-price-4", label: "Distanciel — financement personnel", amount: 500 },
      ],
      programSections: createProgramTemplate("revit-cvc"),
    },
    {
      id: "microsoft-project",
      imageUrl: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxwcm9qZWN0JTIwcGxhbm5pbmclMjBnYW50dCUyMGNoYXJ0fGVufDB8fHx8MTc3ODc3MDEyNHww&ixlib=rb-4.1.0&q=85",
      title: "Microsoft Project",
      description: defaultDescription,
      objectives: defaultObjectives,
      durationDays: 2,
      durationHours: 14,
      order: 5,
      isActive: true,
      prices: [
        { id: "ms-project-price-1", label: "Présentiel — CPF / financement", amount: 700 },
        { id: "ms-project-price-2", label: "Distanciel — CPF / financement", amount: 600 },
        { id: "ms-project-price-3", label: "Présentiel — financement personnel", amount: 500 },
        { id: "ms-project-price-4", label: "Distanciel — financement personnel", amount: 400 },
      ],
      programSections: createProgramTemplate("ms-project"),
    },
    {
      id: "navisworks-manage",
      imageUrl: "https://images.unsplash.com/photo-1527576539890-dfa815648363?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3Nzg3NzAxMjN8MA&ixlib=rb-4.1.0&q=85",
      title: "Navisworks Manage",
      description: defaultDescription,
      objectives: defaultObjectives,
      durationDays: 2,
      durationHours: 14,
      order: 6,
      isActive: true,
      prices: [
        { id: "navisworks-price-1", label: "Présentiel — financement personnel", amount: 500 },
        { id: "navisworks-price-2", label: "Distanciel — financement personnel", amount: 400 },
      ],
      programSections: createProgramTemplate("navisworks"),
    },
  ],
  qcms: [
    {
      id: "qcm-revit-toutes-les-bases",
      title: "Test QCM Revit Toutes les Bases",
      description: "Évaluez gratuitement votre niveau avant de choisir votre formation.",
      order: 1,
      isActive: true,
      questions: [
        createQuestion("qcm-revit-bases-question-1", "Quelle commande permet de créer un mur dans Revit ?", [
          { id: "qcm-revit-bases-question-1-answer-a", text: "Mur" },
          { id: "qcm-revit-bases-question-1-answer-b", text: "Sol" },
          { id: "qcm-revit-bases-question-1-answer-c", text: "Coupe" },
        ], "qcm-revit-bases-question-1-answer-a"),
        createQuestion("qcm-revit-bases-question-2", "Quel élément sert à organiser les niveaux du bâtiment ?", [
          { id: "qcm-revit-bases-question-2-answer-a", text: "Les nomenclatures" },
          { id: "qcm-revit-bases-question-2-answer-b", text: "Les niveaux" },
          { id: "qcm-revit-bases-question-2-answer-c", text: "Les feuilles" },
        ], "qcm-revit-bases-question-2-answer-b"),
      ],
    },
    {
      id: "qcm-revit-architecture",
      title: "Test QCM Revit Architecture",
      description: "Évaluez gratuitement votre niveau avant de choisir votre formation.",
      order: 2,
      isActive: true,
      questions: [
        createQuestion("qcm-revit-archi-question-1", "Quel outil est le plus adapté pour créer une toiture dans Revit Architecture ?", [
          { id: "qcm-revit-archi-question-1-answer-a", text: "Plafond" },
          { id: "qcm-revit-archi-question-1-answer-b", text: "Toit" },
          { id: "qcm-revit-archi-question-1-answer-c", text: "Pièce" },
        ], "qcm-revit-archi-question-1-answer-b"),
        createQuestion("qcm-revit-archi-question-2", "Quel objet permet de gérer les menuiseries dans une façade ?", [
          { id: "qcm-revit-archi-question-2-answer-a", text: "Fenêtre" },
          { id: "qcm-revit-archi-question-2-answer-b", text: "Niveau" },
          { id: "qcm-revit-archi-question-2-answer-c", text: "Zone" },
        ], "qcm-revit-archi-question-2-answer-a"),
      ],
    },
    {
      id: "qcm-revit-structure",
      title: "Test QCM Revit Structure",
      description: "Évaluez gratuitement votre niveau avant de choisir votre formation.",
      order: 3,
      isActive: true,
      questions: [
        createQuestion("qcm-revit-structure-question-1", "Quel élément structural sert généralement de support horizontal principal ?", [
          { id: "qcm-revit-structure-question-1-answer-a", text: "La poutre" },
          { id: "qcm-revit-structure-question-1-answer-b", text: "La pièce" },
          { id: "qcm-revit-structure-question-1-answer-c", text: "La surface topographique" },
        ], "qcm-revit-structure-question-1-answer-a"),
        createQuestion("qcm-revit-structure-question-2", "Quel objet Revit utilise-t-on pour modéliser un poteau béton ?", [
          { id: "qcm-revit-structure-question-2-answer-a", text: "Poteau structurel" },
          { id: "qcm-revit-structure-question-2-answer-b", text: "Composant de détail" },
          { id: "qcm-revit-structure-question-2-answer-c", text: "Texte" },
        ], "qcm-revit-structure-question-2-answer-a"),
      ],
    },
    {
      id: "qcm-revit-cvc-plomberie-electricite",
      title: "Test QCM Revit CVC / Plomberie / Électricité",
      description: "Évaluez gratuitement votre niveau avant de choisir votre formation.",
      order: 4,
      isActive: true,
      questions: [
        createQuestion("qcm-revit-mep-question-1", "Dans Revit MEP, quel élément sert à modéliser un réseau aéraulique ?", [
          { id: "qcm-revit-mep-question-1-answer-a", text: "Gaine" },
          { id: "qcm-revit-mep-question-1-answer-b", text: "Mur" },
          { id: "qcm-revit-mep-question-1-answer-c", text: "Pièce" },
        ], "qcm-revit-mep-question-1-answer-a"),
        createQuestion("qcm-revit-mep-question-2", "Quel connecteur permet de relier les équipements MEP entre eux ?", [
          { id: "qcm-revit-mep-question-2-answer-a", text: "Connecteur MEP" },
          { id: "qcm-revit-mep-question-2-answer-b", text: "Niveau" },
          { id: "qcm-revit-mep-question-2-answer-c", text: "Légende" },
        ], "qcm-revit-mep-question-2-answer-a"),
      ],
    },
    {
      id: "qcm-microsoft-project",
      title: "Test QCM Microsoft Project",
      description: "Évaluez gratuitement votre niveau avant de choisir votre formation.",
      order: 5,
      isActive: true,
      questions: [
        createQuestion("qcm-ms-project-question-1", "Quel affichage est le plus utilisé pour visualiser un planning dans Microsoft Project ?", [
          { id: "qcm-ms-project-question-1-answer-a", text: "Diagramme de Gantt" },
          { id: "qcm-ms-project-question-1-answer-b", text: "Tableau croisé dynamique" },
          { id: "qcm-ms-project-question-1-answer-c", text: "Carte mentale" },
        ], "qcm-ms-project-question-1-answer-a"),
        createQuestion("qcm-ms-project-question-2", "Quel champ permet de lier une tâche à une autre ?", [
          { id: "qcm-ms-project-question-2-answer-a", text: "Prédécesseurs" },
          { id: "qcm-ms-project-question-2-answer-b", text: "Commentaires" },
          { id: "qcm-ms-project-question-2-answer-c", text: "Coût fixe" },
        ], "qcm-ms-project-question-2-answer-a"),
      ],
    },
    {
      id: "qcm-navisworks-manage",
      title: "Test QCM Navisworks Manage",
      description: "Évaluez gratuitement votre niveau avant de choisir votre formation.",
      order: 6,
      isActive: true,
      questions: [
        createQuestion("qcm-navisworks-question-1", "Quel module Navisworks est utilisé pour la détection de conflits ?", [
          { id: "qcm-navisworks-question-1-answer-a", text: "Clash Detective" },
          { id: "qcm-navisworks-question-1-answer-b", text: "Render Studio" },
          { id: "qcm-navisworks-question-1-answer-c", text: "Selection Tree" },
        ], "qcm-navisworks-question-1-answer-a"),
        createQuestion("qcm-navisworks-question-2", "Quel format est fréquemment agrégé dans Navisworks pour coordonner plusieurs disciplines ?", [
          { id: "qcm-navisworks-question-2-answer-a", text: "NWF / NWD" },
          { id: "qcm-navisworks-question-2-answer-b", text: "DOCX" },
          { id: "qcm-navisworks-question-2-answer-c", text: "XLS" },
        ], "qcm-navisworks-question-2-answer-a"),
      ],
    },
  ],
  learningPath: {
    title: "Parcours recommandé",
    subtitle: "5 jours de bases + 5 jours de spécialisation",
    isActive: true,
    baseNodeLabel: "Revit Toutes les Bases",
    baseNodeDuration: "5 jours",
    branchDurationLabel: "5 jours",
    branches: [
      { id: "branch-architecture", label: "Revit Spécialisation Architecture" },
      { id: "branch-structure", label: "Revit Spécialisation Structure" },
      { id: "branch-cvc", label: "Revit Spécialisation CVC / Plomberie / Électricité" },
    ],
  },
  contactBlock: {
    title: "Un besoin en formation ?",
    description: "Contactez-nous pour choisir la formation, le format présentiel ou distanciel, et la solution de financement la plus adaptée.",
    primaryLabel: "Nous contacter",
    primaryHref: "mailto:jad@bimcubes.fr?subject=Demande%20de%20formation",
    secondaryLabel: "jad@bimcubes.fr",
    secondaryHref: "mailto:jad@bimcubes.fr",
    isActive: true,
  },
};

const clone = (value) => JSON.parse(JSON.stringify(value));

const safeString = (value, fallback = "") => {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  return trimmed || fallback;
};

const safeNumber = (value, fallback = 0) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric) || !Number.isFinite(numeric)) return fallback;
  return Math.max(0, numeric);
};

const safeBoolean = (value, fallback = false) => {
  if (typeof value === "boolean") return value;
  return fallback;
};

const buildFallbackAnswers = (questionId = "question") => ([
  { id: `${questionId}-answer-a`, text: "Réponse A" },
  { id: `${questionId}-answer-b`, text: "Réponse B" },
]);

const normalizePrice = (price = {}, fallback = {}, index = 0, formationId = "formation") => ({
  id: safeString(price.id, safeString(fallback.id, `${formationId}-price-${index + 1}`)),
  label: safeString(price.label, safeString(fallback.label, `Tarif ${index + 1}`)),
  amount: safeNumber(price.amount, safeNumber(fallback.amount, 0)),
});

const normalizeProgramSection = (section = {}, fallback = {}, index = 0, formationId = "formation") => {
  const itemsSource = Array.isArray(section.items) && section.items.length ? section.items : fallback.items;
  const items = (Array.isArray(itemsSource) ? itemsSource : []).map((item) => safeString(item)).filter(Boolean);

  return {
    id: safeString(section.id, safeString(fallback.id, `${formationId}-program-${index + 1}`)),
    title: safeString(section.title, safeString(fallback.title, `Section ${index + 1}`)),
    items: items.length ? items : ["Sous-thème à détailler"],
  };
};

const normalizeAnswer = (answer = {}, fallback = {}, index = 0, questionId = "question") => ({
  id: safeString(answer.id, safeString(fallback.id, `${questionId}-answer-${index + 1}`)),
  text: safeString(answer.text, safeString(fallback.text, `Réponse ${index + 1}`)),
});

const normalizeQuestion = (question = {}, fallback = {}, index = 0, qcmId = "qcm") => {
  const questionId = safeString(question.id, safeString(fallback.id, `${qcmId}-question-${index + 1}`));
  const fallbackAnswers = Array.isArray(fallback.answers) && fallback.answers.length ? fallback.answers : buildFallbackAnswers(questionId);
  const sourceAnswers = Array.isArray(question.answers) && question.answers.length ? question.answers : fallbackAnswers;
  const answers = sourceAnswers.map((answer, answerIndex) => normalizeAnswer(answer, fallbackAnswers[answerIndex], answerIndex, questionId));
  const correctAnswerId = safeString(question.correctAnswerId, safeString(fallback.correctAnswerId, answers[0]?.id || ""));

  return {
    id: questionId,
    questionText: safeString(question.questionText, safeString(fallback.questionText, `Question ${index + 1}`)),
    imageUrl: safeString(question.imageUrl, safeString(fallback.imageUrl, "")),
    answers,
    correctAnswerId: answers.some((answer) => answer.id === correctAnswerId) ? correctAnswerId : answers[0]?.id || "",
    explanation: safeString(question.explanation, safeString(fallback.explanation, "")),
  };
};

const normalizeFormation = (formation = {}, fallback = {}, index = 0) => {
  const formationId = safeString(formation.id, safeString(fallback.id, `formation-${index + 1}`));
  const fallbackPrices = Array.isArray(fallback.prices) ? fallback.prices : [];
  const sourcePrices = Array.isArray(formation.prices) && formation.prices.length ? formation.prices : fallbackPrices;
  const fallbackSections = Array.isArray(fallback.programSections) ? fallback.programSections : [];
  const sourceSections = Array.isArray(formation.programSections) && formation.programSections.length ? formation.programSections : fallbackSections;

  return {
    id: formationId,
    imageUrl: safeString(formation.imageUrl, safeString(fallback.imageUrl)),
    title: safeString(formation.title, safeString(fallback.title, `Formation ${index + 1}`)),
    description: safeString(formation.description, safeString(fallback.description, defaultDescription)),
    objectives: safeString(formation.objectives, safeString(fallback.objectives, defaultObjectives)),
    durationDays: safeNumber(formation.durationDays, safeNumber(fallback.durationDays, 1)),
    durationHours: safeNumber(formation.durationHours, safeNumber(fallback.durationHours, 7)),
    order: safeNumber(formation.order, safeNumber(fallback.order, index + 1)),
    isActive: safeBoolean(formation.isActive, safeBoolean(fallback.isActive, true)),
    prices: sourcePrices.map((price, priceIndex) => normalizePrice(price, fallbackPrices[priceIndex], priceIndex, formationId)),
    programSections: sourceSections.map((section, sectionIndex) => normalizeProgramSection(section, fallbackSections[sectionIndex], sectionIndex, formationId)),
  };
};

const normalizeQcm = (qcm = {}, fallback = {}, index = 0) => {
  const qcmId = safeString(qcm.id, safeString(fallback.id, `qcm-${index + 1}`));
  const fallbackQuestions = Array.isArray(fallback.questions) ? fallback.questions : [];
  const sourceQuestions = Array.isArray(qcm.questions) ? qcm.questions : fallbackQuestions;

  return {
    id: qcmId,
    title: safeString(qcm.title, safeString(fallback.title, `Test QCM ${index + 1}`)),
    description: safeString(qcm.description, safeString(fallback.description, "Évaluez gratuitement votre niveau avant de choisir votre formation.")),
    order: safeNumber(qcm.order, safeNumber(fallback.order, index + 1)),
    isActive: safeBoolean(qcm.isActive, safeBoolean(fallback.isActive, true)),
    questions: sourceQuestions.map((question, questionIndex) => normalizeQuestion(question, fallbackQuestions[questionIndex], questionIndex, qcmId)),
  };
};

const mergeWithDefaultsById = (defaults, incomingItems, normalizer) => {
  const items = [];
  const usedIds = new Set();

  defaults.forEach((fallback, index) => {
    const matching = incomingItems.find((item) => item?.id === fallback.id) || incomingItems[index] || {};
    items.push(normalizer(matching, fallback, index));
    usedIds.add(fallback.id);
  });

  incomingItems.filter((item) => item?.id && !usedIds.has(item.id)).forEach((item, extraIndex) => {
    items.push(normalizer(item, {}, defaults.length + extraIndex));
  });

  return items;
};

export const normalizeFormationsPageData = (payload = {}) => {
  const defaults = clone(defaultFormationsPageData);
  const incomingFormations = Array.isArray(payload.formations) ? payload.formations : [];
  const incomingQcms = Array.isArray(payload.qcms) ? payload.qcms : [];
  const incomingLearningPath = payload.learningPath && typeof payload.learningPath === "object" ? payload.learningPath : {};
  const incomingContactBlock = payload.contactBlock && typeof payload.contactBlock === "object" ? payload.contactBlock : {};

  const formations = mergeWithDefaultsById(defaults.formations, incomingFormations, normalizeFormation).sort((left, right) => left.order - right.order || left.title.localeCompare(right.title));
  const qcms = mergeWithDefaultsById(defaults.qcms, incomingQcms, normalizeQcm).sort((left, right) => left.order - right.order || left.title.localeCompare(right.title));

  const learningPath = {
    title: safeString(incomingLearningPath.title, defaults.learningPath.title),
    subtitle: safeString(incomingLearningPath.subtitle, defaults.learningPath.subtitle),
    isActive: safeBoolean(incomingLearningPath.isActive, defaults.learningPath.isActive),
    baseNodeLabel: safeString(incomingLearningPath.baseNodeLabel, defaults.learningPath.baseNodeLabel),
    baseNodeDuration: safeString(incomingLearningPath.baseNodeDuration, defaults.learningPath.baseNodeDuration),
    branchDurationLabel: safeString(incomingLearningPath.branchDurationLabel, defaults.learningPath.branchDurationLabel),
    branches: defaults.learningPath.branches.map((fallback, index) => {
      const sourceBranches = Array.isArray(incomingLearningPath.branches) ? incomingLearningPath.branches : [];
      const matching = sourceBranches.find((item) => item?.id === fallback.id) || sourceBranches[index] || {};
      return { id: safeString(matching.id, fallback.id), label: safeString(matching.label, fallback.label) };
    }),
  };

  const contactBlock = {
    title: safeString(incomingContactBlock.title, defaults.contactBlock.title),
    description: safeString(incomingContactBlock.description, defaults.contactBlock.description),
    primaryLabel: safeString(incomingContactBlock.primaryLabel, defaults.contactBlock.primaryLabel),
    primaryHref: safeString(incomingContactBlock.primaryHref, defaults.contactBlock.primaryHref),
    secondaryLabel: safeString(incomingContactBlock.secondaryLabel, defaults.contactBlock.secondaryLabel),
    secondaryHref: safeString(incomingContactBlock.secondaryHref, defaults.contactBlock.secondaryHref),
    isActive: safeBoolean(incomingContactBlock.isActive, defaults.contactBlock.isActive),
  };

  return { id: safeString(payload.id, defaults.id), createdAt: safeString(payload.createdAt, defaults.createdAt), updatedAt: safeString(payload.updatedAt, defaults.updatedAt), formations, qcms, learningPath, contactBlock };
};

export const cloneFormationsPageData = () => normalizeFormationsPageData(clone(defaultFormationsPageData));
export const formatPriceHT = (value) => `${new Intl.NumberFormat("fr-FR").format(safeNumber(value, 0))} € HT`;

export const getPrimaryFormationPrice = (formation) => {
  const prices = Array.isArray(formation?.prices) ? formation.prices : [];
  if (!prices.length) return 0;
  return prices.reduce((highest, price) => Math.max(highest, safeNumber(price.amount, 0)), 0);
};

export const getSecondaryFormationPrice = (formation) => {
  const prices = Array.isArray(formation?.prices) ? formation.prices : [];
  const personalPrices = prices.filter((price) => `${price.label || ""}`.toLowerCase().includes("personnel"));
  const source = personalPrices.length ? personalPrices : prices;
  if (!source.length) return 0;
  return source.reduce((lowest, price) => Math.min(lowest, safeNumber(price.amount, 0)), safeNumber(source[0].amount, 0));
};

export const getSortedActiveFormations = (data) => [...(data?.formations || [])].filter((formation) => formation.isActive).sort((left, right) => left.order - right.order || left.title.localeCompare(right.title));
export const getSortedActiveQcms = (data) => [...(data?.qcms || [])].filter((qcm) => qcm.isActive).sort((left, right) => left.order - right.order || left.title.localeCompare(right.title));

export const createEmptyPriceLine = (formationId = "formation") => ({ id: `${formationId}-price-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, label: "Nouveau tarif", amount: 0 });
export const createEmptyProgramSection = (formationId = "formation") => ({ id: `${formationId}-program-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, title: "Nouvelle section", items: ["Sous-thème 1", "Sous-thème 2"] });
export const createEmptyQcmAnswer = (questionId = "question") => ({ id: `${questionId}-answer-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, text: "Nouvelle réponse" });

export const createEmptyQcmQuestion = (qcmId = "qcm") => {
  const questionId = `${qcmId}-question-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const firstAnswer = createEmptyQcmAnswer(questionId);
  const secondAnswer = createEmptyQcmAnswer(questionId);
  return { id: questionId, questionText: "Nouvelle question", imageUrl: "", answers: [firstAnswer, secondAnswer], correctAnswerId: firstAnswer.id, explanation: "" };
};

export const createEmptyQcmTest = () => ({ id: `qcm-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, title: "Nouveau test QCM", description: "Évaluez gratuitement votre niveau avant de choisir votre formation.", order: 99, isActive: true, questions: [] });

export const shuffleArray = (items = []) => {
  const next = [...items];
  for (let index = next.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [next[index], next[randomIndex]] = [next[randomIndex], next[index]];
  }
  return next;
};